// @ts-ignore
import React, {useState} from "react";
import {Modal} from "../../../shared";
import styles from "./ShowAgreements.module.scss"
import {useAppDispatch} from "../../../core/hooks";
import cx from "classnames";
import GenerateContract from "./GenerateContract";
import GenerateInvoice from "./GenerateInvoice";

import DopDocuments from "./DopDocuments";

// @ts-ignore
const ShowAgreements = ({contract, request, selectedModalBrigade, showAgreements, setShowAgreementsModal, emergency_org, emergency_city }) => {
  const [agreement, setAgreement] = useState(true);
  const [invoice, setInvoice] = useState(false);
  const [dopDocuments, setDopDocuments] = useState(false);
  const [contractTab] = useState(true)
  const [uploadDocuments, setUploadDocuments] = useState(false);

  const [generatedContract, setGeneratedContract] = useState()
  const [generatedInvoice, setGeneratedInvoice] = useState()
  const [selectedFiles, setSelectedFiles] = useState([]);
  const dispatch = useAppDispatch()

  return  <Modal open={showAgreements}
                 className={styles.modalContainer}
                 closeIcon
                 title={contractTab ? 'Предварительный просмотр' : 'Составить Договор'}
                 handleClose={() => {
                   setShowAgreementsModal(false)
                 }}>
     <div style={{display: "flex", flexDirection: "column", height: '100%', overflow: "hidden"}}>
      <div className={styles.containerTab}>
        <div className={styles.header}>
          <button
            type="button"
            id="perActTab"
            className={cx(styles.tab, { [styles.active]: agreement })}
            onClick={() => {
              setAgreement(true);
              setInvoice(false);
              setDopDocuments(false);
            }}
          >
                  <span className={styles.tabName} id="perActTitle">
                    Договор
                  </span>
          </button>
          { request.customer_type === 2 && <button
            type="button"
            id="perActTab"
            className={cx(styles.tab, {[styles.active]: invoice})}
            onClick={() => {
              setAgreement(false);
              setInvoice(true);
              setDopDocuments(false);
            }}
          >
                  <span className={styles.tabName} id="perActTitle">
                    Инвойс
                  </span>
          </button>}
          <button
            type="button"
            id="perActTab"
            className={cx(styles.tab, { [styles.active]: dopDocuments })}
            onClick={() => {
              setAgreement(false);
              setInvoice(false);
              setDopDocuments(true);
            }}
          >
                  <span className={styles.tabName} id="perActTitle">
                    Доп. документы
                  </span>
          </button>
        </div>
        <div className={styles.containerContent}>
          <div className={cx(styles.content)}>
            <div className={cx(styles.tabContent, agreement && styles.active)}>
              {agreement && <div>
                <GenerateContract emergency_city={emergency_city} emergency_org={emergency_org} contract={contract} isShowContract={true} request={request} setGeneratedContract={setGeneratedContract}/>
              </div>}
            </div>
            <div className={cx(styles.tabContent, invoice && styles.active)}>
              {invoice && request.customer_type === 2 && <GenerateInvoice contract={contract} isShowContract={true}  request={request} setGeneratedInvoice={setGeneratedInvoice}/>}
            </div>
            <div className={cx(styles.tabContent, dopDocuments && styles.active)}>
              {dopDocuments && <DopDocuments contract={contract} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
}
export default ShowAgreements
